// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/OperacaoServiceOrders_TimelineResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/operacao_service_orders/timeline.
 *
 * Returns one TimelinePointRow per time bucket, ordered ascending.
 * The bucket size is selected by the `bucket` query parameter
 * (`day` | `week` | `month`, default `day`).
 */
import type { OperacaoServiceOrders_TimelinePointRow } from './OperacaoServiceOrders_TimelinePointRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface OperacaoServiceOrders_TimelineResponseDados {
bucket: string
points: OperacaoServiceOrders_TimelinePointRow[]
}

export type OperacaoServiceOrders_TimelineResponse = ApiResponse<OperacaoServiceOrders_TimelineResponseDados>;

registerResponseContract('OperacaoServiceOrders_TimelineResponse', {
  bucket: { type: 'string',  required: true },
  points: {
    type: 'array',
    required: true,
    items: {
      bucket_label:    { type: 'string',  required: true },
      orders_count:    { type: 'number',  required: true },
      items_delivered: { type: 'number',  required: true },
    },
  },
})
